import { map } from 'lodash';
import { calculateDaysElapsed } from 'utils';

export const decorateProduct = (product, startedAt) => {
  const daysElapsed = calculateDaysElapsed(startedAt);
  const currentWeek = Math.floor(daysElapsed / 7) + 1;
  const currentDay = daysElapsed % 7 + 1;
  const percentElapsed = Math.min(
    Math.max(daysElapsed / (product.weeks.length * 7) * 100, 0),
    100
  );
  const isGraduated = percentElapsed === 100;
  const weeks = map(product.weeks, (week, index) => {
    week.weekNumber = index + 1;
    return week;
  });

  return {
    ...product,
    weeks,
    startedAt,
    currentWeek,
    currentDay,
    daysElapsed,
    isGraduated,
    percentElapsed,
  };
};



// WEBPACK FOOTER //
// ./src/decorators/decorateProduct.js